import React, { useEffect, useState } from "react";
import { useSelector } from 'react-redux';
import { Button } from "reactstrap";
import nativeSender from 'helpers/nativeSender';
import LaboratoryService from "services/LaboratoryService";
import MultimediaService from "services/MultimediaService";

function base64ToArrayBuffer(base64) {
    var binaryString = window.atob(base64);
    var binaryLen = binaryString.length;
    var bytes = new Uint8Array(binaryLen);
    for (var i = 0; i < binaryLen; i++) {
        var ascii = binaryString.charCodeAt(i);
        bytes[i] = ascii;
    }
    return bytes;
}
// Function will execute on click of button
const convertPDFToUrl = async (reportId, doctorId, patientId, practiceId, nativeWebView) => {
    try {
        if (nativeWebView) {
            return nativeSender.send('DOWNLOAD_REPORT', { reportId: reportId, doctorId: doctorId, patientId: patientId, practiceId: practiceId });
        }
        
        const reportFileData = await LaboratoryService.getStudyReportFile(reportId, doctorId, patientId, practiceId);
        const reportFile = await reportFileData.data.data;
        let bytes = "";
        let fileName = reportFileData.data.name ? reportFileData.data.name : `${reportId}.pdf`;

        if (reportFile.length < 25) {
            //Report file is an objectID
            const res = await MultimediaService.getReportFile(reportFile)
            bytes = base64ToArrayBuffer(res.data);
            fileName = res.name;
        } else {
            //Report file is an old decripted file
            bytes = base64ToArrayBuffer(reportFile);
        }

        // using Java Script method to get PDF file
        var blob = new Blob([bytes], { type: "application/pdf" });
        // Creating new object of PDF file
        const fileURL = window.URL.createObjectURL(blob);

        //const linkSource = `data:application/pdf;base64,${reportFile}`;
        const downloadLink = document.createElement("a");
        downloadLink.href = fileURL;
        downloadLink.download = fileName;
        downloadLink.click();
        //return fileURL
    } catch (error) {
        console.log(error);
    }
}

const PdfLoadingButton = ({ reportId, doctorId, patientId, practiceId, prompt, buttonSize }) => {
    const [isLoading, setIsLoading] = useState(false);
    const { nativeWebView } = useSelector(state => state.commonReducer);

    useEffect(() => {
        if (isLoading) {
            convertPDFToUrl(reportId, doctorId, patientId, practiceId, nativeWebView).then(() => {
                setIsLoading(false);
            })
        }
    }, [isLoading]);

    const handleClick = () => setIsLoading(true);
    return (
        <Button
            size={buttonSize}
            color="info"
            onClick={!isLoading ? handleClick : null}
            target="_blank"
            rel="noopener noreferrer"
            disabled={isLoading}
        >
            {isLoading ? "..." : prompt}

        </Button>
    )
}

export default PdfLoadingButton;